/**
 * The facilitator called this person to the pre-check (the stream's `assessment.catch_up`, sent to them alone): kept for the session so any page of the bank can say so
 * and link to the check, until they follow the link. Per session, in memory: after a reload the call is gone, and the check stays reachable from the invite.
 */
import { useSyncExternalStore } from "react";
import type { SseEvent } from "@bsim/contracts";
import { forgetPreCheckLater } from "../checkin/postDone";

const called = new Set<string>();
const listeners = new Set<() => void>();
const notify = (): void => listeners.forEach((l) => l());

/** Called for every stream event; keeps only the pre-check call. */
export function noteCalledIn(e: SseEvent): void {
  if (e.type !== "assessment.catch_up" || e.data.phase !== "pre") return;
  called.add(e.cohortId);
  forgetPreCheckLater(e.cohortId); // a new call after "Do it later" is heard
  notify();
}

/** The person is on their way to the check: the banner has done its job. */
export function clearCalledIn(cohortId: string): void {
  if (called.delete(cohortId)) notify();
}

export const useCalledIn = (cohortId: string): boolean =>
  useSyncExternalStore((l) => { listeners.add(l); return () => { listeners.delete(l); }; }, () => called.has(cohortId));
